// 按模块的action, reducer整合体
import localDb from '@util/localDb';
import { queryMyFunctionListTree } from '@api/core/function';

export const GET_MENU = 'GET_MENU';

// Action
export function getMenu() {
  return dispatch => {
    queryMyFunctionListTree().then(res => {
      localDb.set('menu', res.data);
      dispatch({
        type: GET_MENU,
        data: res.data,
      });
    });
  };
}

// Reducer
export function menu(state = {}, action) {
  switch (action.type) {
    case GET_MENU:
      return action.data;
    default:
      return localDb.get('menu');
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js